import axios from '@/utilities/api/axios';

const initialState = () => ({
  aroundMe: [],
  aroundMeError: null,
  aroundMeLoading: false
});

export const state = initialState();

export const actions = {
  /**
   * @param { object { latitude: Number, longitude: Number, maxDistance: Number } } payload
   */
  getAroundMe: async ({ commit }, payload) => {
    commit('mutateAroundMeLoading', true);
    try {
      const { query } = payload;
      const { data } = await axios.get(
        `/around-me/aroundme-new`,
        {
          params: query
        }
      );
      commit('mutateAroundMe', data);
      commit('mutateAroundMeError', null);
    } catch (error) {
      commit('mutateAroundMe', []);
      commit('mutateAroundMeError', error);
    }
    commit('mutateAroundMeLoading', false);
  }
};

export const mutations = {
  mutateAroundMe: (state, payload) => {
    state.aroundMe = payload;
  },
  mutateAroundMeError: (state, payload) => {
    state.aroundMeError = payload;
  },
  mutateAroundMeLoading: (state, payload) => {
    state.aroundMeLoading = payload;
  }
};
